import { LogType } from '../../../models/logs/LogType.enum';

/**
 * Maps a PO job type from the backend ("JobCost" / "Service") to the receiving log type.
 *
 * @param jobType - The job type string from the PO data.
 * @returns The corresponding LogType, or null if the job type is unrecognized.
 */
export function logTypeFromJobType(jobType: string): LogType | null {
  if (jobType === 'JobCost') {
    return LogType.Project;
  }
  if (jobType === 'Service') {
    return LogType.Service;
  }
  return null;
}
